import React from 'react';
import classNames from 'classnames';
import CommonTypography from '@src/new-components/Typography';
import { StyledConfigRow } from './index.style';

const ConfigRow = ({ label, disabled, children }) => (
  <StyledConfigRow className={classNames({ 'config-row-disabled': disabled })}>
    <CommonTypography className="config-row-label" variant="body-14-medium">
      {label}
    </CommonTypography>
    <div className="config-row-control">{children}</div>
  </StyledConfigRow>
);

export default ConfigRow;
